/* eslint-disable camelcase */
import { action, makeObservable, observable, runInAction } from 'mobx';
import { SettingsStore } from 'src/stores/SettingsStore/SettingsStore';

export class AuthStoreClass {
    constructor() {
        makeObservable(this);
    }

    @observable authenticated = false;
    @observable actionIdentifier?: string;
    @observable token?: string;

    @action async authenticate() {
        try {
            const authenticated = await SettingsStore.keycloak.init({
                onLoad: 'check-sso',
                silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
                pkceMethod: 'S256',
            });

            if (!authenticated) {
                await SettingsStore.keycloak.login();
                return;
            }

            runInAction(() => {
                this.authenticated = authenticated;
                this.token = SettingsStore.keycloak.token;
            });
        } catch (error) {
            runInAction(() => {
                this.authenticated = false;
            });
            this.logout();
        }
    }

    @action async logout(redirectUrl?: string) {
        await SettingsStore.keycloak?.logout({
            redirectUri:
                redirectUrl ||
                `${window.location.protocol}//${window.location.host}`,
        });
    }
}

const getAuthStore = () => {
    return new AuthStoreClass();
};

export const AuthStore = getAuthStore();
